import styled from "styled-components";

const ImageMediumRoot = styled.div`
  height: 300px;
`;

export default ImageMediumRoot;
